var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.33 87.96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.92 10.6l-9.12-9.17a4.87 4.87 0 00-6.87-.03L41.71 57.99l-24.2-24.33a4.87 4.87 0 00-6.87-.03l-9.2 9.11a4.838 4.838 0 00-.03 6.85l36.75 36.94a4.87 4.87 0 006.87.03l69.86-69.11c1.9-1.88 1.92-4.95.03-6.85z",
    fill: "#45ad4a"
  })));
}
export default SvgGreenTick;